import { render, staticRenderFns } from "./image-upload.vue?vue&type=template&id=f67cabf4&"
import script from "./image-upload.vue?vue&type=script&lang=js&"
export * from "./image-upload.vue?vue&type=script&lang=js&"
import style0 from "./image-upload.vue?vue&type=style&index=0&id=f67cabf4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports